module.exports = __webpack_public_path__ + "c48e82b483791ff672cf295ed015b684.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/customer-service-white.svg
// module id = 1319
// module chunks = 61